// Design tokens are hex values — use var() directly; hsl(var(...)) resolves to black in SVG.
export const CHART_AXIS_TICK = { fontSize: 11, fill: "var(--muted-foreground)" } as const;
export const CHART_GRID_STROKE = "var(--border)";
export const KPI_CHART_HEIGHT = 332;
